@if (chartOptions.series) {
  <highcharts-chart
    [options]="chartOptions"
    [(update)]="updateFlag"
    [oneToOne]="true"
    style="width: 100%; height: 250px; display: block"
  ></highcharts-chart>
}
